<template>
  <div class="content">
    <div class="container-fluid">
      <!-- Header -->
      <div class="row">
        <div class="col-12">
          <div class="card trainer-progress-header">
            <div class="card-header trainer-card-header">
              <h4 class="card-title trainer-title">
                <i class="nc-icon nc-chart-bar-32"></i>
                Progreso de Clientes
              </h4>
              <p class="card-category trainer-subtitle">
                Monitorea el progreso y resultados de tus clientes
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Filtros y Selección -->
      <div class="row">
        <div class="col-12">
          <div class="card trainer-card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <select class="form-control" v-model="selectedClient">
                    <option value="">Todos los clientes</option>
                    <option v-for="client in clients" :key="client.id" :value="client.id">
                      {{ client.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-4">
                  <select class="form-control" v-model="timeRange">
                    <option value="7">Últimos 7 días</option>
                    <option value="30">Último mes</option>
                    <option value="90">Últimos 3 meses</option>
                    <option value="365">Último año</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <select class="form-control" v-model="metricType">
                    <option value="all">Todas las métricas</option>
                    <option value="weight">Peso</option>
                    <option value="strength">Fuerza</option>
                    <option value="cardio">Cardio</option>
                    <option value="measurements">Medidas</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Resumen General -->
      <div class="row">
        <div class="col-lg-3 col-md-6">
          <div class="card card-stats trainer-stats-card">
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <div class="icon-big text-center">
                    <i class="nc-icon nc-chart-pie-36 text-success"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p class="card-category">Clientes Mejorando</p>
                    <p class="card-title trainer-number">89%</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-lg-3 col-md-6">
          <div class="card card-stats trainer-stats-card">
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <div class="icon-big text-center">
                    <i class="nc-icon nc-minimal-up text-primary"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p class="card-category">Mejora Promedio</p>
                    <p class="card-title trainer-number">+23%</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-lg-3 col-md-6">
          <div class="card card-stats trainer-stats-card">
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <div class="icon-big text-center">
                    <i class="nc-icon nc-trophy text-warning"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p class="card-category">Objetivos Logrados</p>
                    <p class="card-title trainer-number">74%</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-lg-3 col-md-6">
          <div class="card card-stats trainer-stats-card">
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <div class="icon-big text-center">
                    <i class="nc-icon nc-time-alarm text-info"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p class="card-category">Adherencia</p>
                    <p class="card-title trainer-number">87%</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Progreso Individual o General -->
      <div class="row" v-if="selectedClient">
        <!-- Cliente Individual -->
        <div class="col-lg-8">
          <div class="card trainer-card">
            <div class="card-header">
              <h6 class="card-title">Progreso de {{ getClientName(selectedClient) }}</h6>
            </div>
            <div class="card-body">
              <div class="trainer-progress-chart">
                <canvas id="progressChart" width="400" height="200"></canvas>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-lg-4">
          <div class="card trainer-card">
            <div class="card-header">
              <h6 class="card-title">Métricas Clave</h6>
            </div>
            <div class="card-body">
              <div class="trainer-key-metrics">
                <div class="trainer-metric-item">
                  <div class="trainer-metric-label">
                    <i class="nc-icon nc-chart-bar-32 text-primary"></i>
                    <span>Peso</span>
                  </div>
                  <div class="trainer-metric-value">
                    <strong>-4.2 kg</strong>
                    <small class="text-success">↓ 6.1%</small>
                  </div>
                </div>
                
                <div class="trainer-metric-item">
                  <div class="trainer-metric-label">
                    <i class="nc-icon nc-user-run text-success"></i>
                    <span>Fuerza</span>
                  </div>
                  <div class="trainer-metric-value">
                    <strong>+15 kg</strong>
                    <small class="text-success">↑ 23%</small>
                  </div>
                </div>
                
                <div class="trainer-metric-item">
                  <div class="trainer-metric-label">
                    <i class="nc-icon nc-chart-pie-36 text-warning"></i>
                    <span>Resistencia</span>
                  </div>
                  <div class="trainer-metric-value">
                    <strong>+8 min</strong>
                    <small class="text-success">↑ 32%</small>
                  </div>
                </div>
                
                <div class="trainer-metric-item">
                  <div class="trainer-metric-label">
                    <i class="nc-icon nc-settings-gear-65 text-info"></i>
                    <span>Flexibilidad</span>
                  </div>
                  <div class="trainer-metric-value">
                    <strong>+5 cm</strong>
                    <small class="text-success">↑ 18%</small>
                  </div>
                </div>
              </div>
              
              <hr>
              
              <div class="trainer-goal-progress">
                <h6>Progreso del Objetivo</h6>
                <div class="progress mb-2">
                  <div class="progress-bar trainer-progress-bar" style="width: 78%"></div>
                </div>
                <div class="d-flex justify-content-between">
                  <span>78% completado</span>
                  <span>22% restante</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Vista General de Clientes -->
      <div class="row" v-else>
        <div class="col-12">
          <div class="card trainer-card">
            <div class="card-header">
              <h6 class="card-title">Resumen de Progreso por Cliente</h6>
            </div>
            <div class="card-body p-0">
              <div class="table-responsive">
                <table class="table trainer-progress-table">
                  <thead>
                    <tr>
                      <th>Cliente</th>
                      <th>Objetivo</th>
                      <th>Progreso General</th>
                      <th>Peso</th>
                      <th>Fuerza</th>
                      <th>Resistencia</th>
                      <th>Última Actualización</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="client in clientsProgress" :key="client.id">
                      <td>
                        <div class="trainer-client-info">
                          <img :src="client.avatar" :alt="client.name" class="trainer-client-avatar">
                          <div>
                            <strong>{{ client.name }}</strong>
                            <br><small class="text-muted">{{ client.startDate }}</small>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span class="badge trainer-goal-badge" :class="getGoalClass(client.goal)">
                          {{ client.goal }}
                        </span>
                      </td>
                      <td>
                        <div class="trainer-progress-indicator">
                          <div class="progress">
                            <div 
                              class="progress-bar trainer-progress-bar" 
                              :style="{ width: client.overallProgress + '%' }"
                            ></div>
                          </div>
                          <span class="trainer-progress-text">{{ client.overallProgress }}%</span>
                        </div>
                      </td>
                      <td>
                        <div class="trainer-metric-change" :class="getChangeClass(client.weightChange)">
                          <span>{{ client.weightChange > 0 ? '+' : '' }}{{ client.weightChange }} kg</span>
                          <i :class="getChangeIcon(client.weightChange)"></i>
                        </div>
                      </td>
                      <td>
                        <div class="trainer-metric-change" :class="getChangeClass(client.strengthChange)">
                          <span>{{ client.strengthChange > 0 ? '+' : '' }}{{ client.strengthChange }}%</span>
                          <i :class="getChangeIcon(client.strengthChange)"></i>
                        </div>
                      </td>
                      <td>
                        <div class="trainer-metric-change" :class="getChangeClass(client.enduranceChange)">
                          <span>{{ client.enduranceChange > 0 ? '+' : '' }}{{ client.enduranceChange }}%</span>
                          <i :class="getChangeIcon(client.enduranceChange)"></i>
                        </div>
                      </td>
                      <td>{{ formatDate(client.lastUpdate) }}</td>
                      <td>
                        <div class="trainer-actions">
                          <button class="btn btn-sm btn-outline-primary" @click="viewDetailedProgress(client)">
                            <i class="nc-icon nc-chart-bar-32"></i>
                          </button>
                          <button class="btn btn-sm btn-outline-info" @click="addProgressNote(client)">
                            <i class="nc-icon nc-paper"></i>
                          </button>
                          <button class="btn btn-sm btn-outline-success" @click="scheduleReeval(client)">
                            <i class="nc-icon nc-calendar-60"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Alertas y Notificaciones -->
      <div class="row">
        <div class="col-lg-6">
          <div class="card trainer-card">
            <div class="card-header">
              <h6 class="card-title">Alertas de Progreso</h6>
            </div>
            <div class="card-body">
              <div class="trainer-alerts">
                <div class="trainer-alert-item trainer-alert-warning">
                  <i class="nc-icon nc-bell-55"></i>
                  <div>
                    <strong>María González</strong> no ha registrado progreso en 2 semanas
                    <br><small>Considera programar una reevaluación</small>
                  </div>
                </div>
                
                <div class="trainer-alert-item trainer-alert-success">
                  <i class="nc-icon nc-trophy"></i>
                  <div>
                    <strong>Carlos Ruiz</strong> ha superado su objetivo de fuerza
                    <br><small>¡Excelente progreso! Considera ajustar metas</small>
                  </div>
                </div>
                
                <div class="trainer-alert-item trainer-alert-info">
                  <i class="nc-icon nc-chart-pie-36"></i>
                  <div>
                    <strong>Ana Martínez</strong> muestra mejora constante
                    <br><small>Progreso estable en todas las métricas</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-lg-6">
          <div class="card trainer-card">
            <div class="card-header">
              <h6 class="card-title">Próximas Reevaluaciones</h6>
            </div>
            <div class="card-body">
              <div class="trainer-upcoming-revals">
                <div class="trainer-reval-item" v-for="reval in upcomingReevaluations" :key="reval.id">
                  <div class="trainer-reval-date">
                    <strong>{{ reval.dayMonth }}</strong>
                    <br><small>{{ reval.time }}</small>
                  </div>
                  <div class="trainer-reval-client">
                    <img :src="reval.client.avatar" :alt="reval.client.name" class="trainer-reval-avatar">
                    <div>
                      <strong>{{ reval.client.name }}</strong>
                      <br><small>{{ reval.type }}</small>
                    </div>
                  </div>
                  <div class="trainer-reval-actions">
                    <button class="btn btn-sm btn-outline-primary">Preparar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClientProgress',
  data() {
    return {
      selectedClient: '',
      timeRange: '30',
      metricType: 'all',
      clients: [
        { id: 1, name: 'Ana Martínez' },
        { id: 2, name: 'Carlos Ruiz' },
        { id: 3, name: 'María González' },
        { id: 4, name: 'José López' }
      ],
      clientsProgress: [
        {
          id: 1,
          name: 'Ana Martínez',
          avatar: '/static/img/faces/ayo-ogunseinde-2.jpg',
          goal: 'Pérdida de peso',
          startDate: 'Inicio: 15 Nov 2023',
          overallProgress: 78,
          weightChange: -4.2,
          strengthChange: 15,
          enduranceChange: 32,
          lastUpdate: '2024-01-18'
        },
        {
          id: 2,
          name: 'Carlos Ruiz',
          avatar: '/static/img/faces/erik-lucatero-2.jpg',
          goal: 'Ganancia de músculo',
          startDate: 'Inicio: 20 Oct 2023',
          overallProgress: 85,
          weightChange: 2.8,
          strengthChange: 28,
          enduranceChange: 12,
          lastUpdate: '2024-01-17'
        },
        {
          id: 3,
          name: 'María González',
          avatar: '/static/img/faces/avatar.png',
          goal: 'Mejora de condición',
          startDate: 'Inicio: 5 Dic 2023',
          overallProgress: 45,
          weightChange: -0.8,
          strengthChange: 8,
          enduranceChange: 25,
          lastUpdate: '2024-01-05'
        },
        {
          id: 4,
          name: 'José López',
          avatar: '/static/img/faces/erik-lucatero-2.jpg',
          goal: 'Rehabilitación',
          startDate: 'Inicio: 10 Ene 2024',
          overallProgress: 65,
          weightChange: 0.5,
          strengthChange: 12,
          enduranceChange: 18,
          lastUpdate: '2024-01-19'
        }
      ],
      upcomingReevaluations: [
        {
          id: 1,
          dayMonth: '25 Ene',
          time: '14:00',
          client: {
            name: 'Ana Martínez',
            avatar: '/static/img/faces/ayo-ogunseinde-2.jpg'
          },
          type: 'Reevaluación mensual'
        },
        {
          id: 2,
          dayMonth: '28 Ene',
          time: '16:30',
          client: {
            name: 'Carlos Ruiz',
            avatar: '/static/img/faces/erik-lucatero-2.jpg'
          },
          type: 'Test de fuerza'
        }
      ]
    }
  },
  methods: {
    getClientName(clientId) {
      const client = this.clients.find(c => c.id == clientId);
      return client ? client.name : '';
    },
    getGoalClass(goal) {
      const classes = {
        'Pérdida de peso': 'badge-warning',
        'Ganancia de músculo': 'badge-success',
        'Mejora de condición': 'badge-info',
        'Rehabilitación': 'badge-danger'
      };
      return classes[goal] || 'badge-secondary';
    },
    getChangeClass(change) {
      if (change > 0) return 'text-success';
      if (change < 0) return 'text-danger';
      return 'text-muted';
    },
    getChangeIcon(change) {
      if (change > 0) return 'nc-icon nc-minimal-up';
      if (change < 0) return 'nc-icon nc-minimal-down';
      return 'nc-icon nc-simple-remove';
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('es-ES');
    },
    viewDetailedProgress(client) {
      this.selectedClient = client.id;
    },
    addProgressNote(client) {
      this.$swal.fire({
        title: 'Añadir Nota de Progreso',
        text: `Añadir nota para ${client.name}`,
        confirmButtonColor: '#9ACD32'
      });
    },
    scheduleReeval(client) {
      this.$swal.fire({
        title: 'Programar Reevaluación',
        text: `Programar reevaluación para ${client.name}`,
        confirmButtonColor: '#9ACD32'
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  --trainer-primary: #9ACD32;
  --trainer-secondary: #7CB342;
  --trainer-accent: #8BC34A;
  --trainer-dark: #689F38;
  --trainer-light: #DCEDC8;
  --trainer-bg: #F1F8E9;
}

.trainer-progress-header {
  background: linear-gradient(135deg, var(--trainer-primary), var(--trainer-secondary));
  color: white;
  border: none;
  box-shadow: 0 4px 20px 0px rgba(154, 205, 50, 0.14), 0 7px 10px -5px rgba(154, 205, 50, 0.4);
  
  .trainer-card-header {
    background: transparent;
    border: none;
  }
  
  .trainer-title {
    color: white;
    font-weight: 500;
    margin-bottom: 5px;
    
    i {
      margin-right: 10px;
    }
  }
  
  .trainer-subtitle {
    color: rgba(255,255,255,0.8);
    margin: 0;
  }
}

.trainer-card {
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  margin-bottom: 20px;
  
  .card-header {
    background: var(--trainer-bg);
    border-bottom: 1px solid #dee2e6;
    
    .card-title {
      color: var(--trainer-dark);
      font-weight: 600;
      margin: 0;
    }
  }
}

.trainer-stats-card {
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 5px 25px 0 rgba(0,0,0,0.15);
    transform: translateY(-2px);
  }
  
  .trainer-number {
    font-size: 24px;
    font-weight: 700;
    color: var(--trainer-dark);
  }
}

.trainer-key-metrics {
  .trainer-metric-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 6px;
    margin-bottom: 15px;
    
    .trainer-metric-label {
      display: flex;
      align-items: center;
      
      i {
        font-size: 18px;
        margin-right: 10px;
      }
      
      span {
        font-weight: 500;
        color: var(--trainer-dark);
      }
    }
    
    .trainer-metric-value {
      text-align: right;
      
      strong {
        display: block;
        font-size: 16px;
        color: var(--trainer-dark);
      }
      
      small {
        font-size: 12px;
        font-weight: 600;
      }
    }
  }
}

.trainer-goal-progress {
  text-align: center;
  
  h6 {
    color: var(--trainer-dark);
    margin-bottom: 10px;
  }
  
  .trainer-progress-bar {
    background: var(--trainer-primary);
  }
}

.trainer-progress-table {
  .trainer-client-info {
    display: flex;
    align-items: center;
    
    .trainer-client-avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 12px;
      object-fit: cover;
    }
  }
  
  .trainer-goal-badge {
    font-size: 11px;
    padding: 4px 8px;
  }
  
  .trainer-progress-indicator {
    display: flex;
    align-items: center;
    gap: 10px;
    
    .progress {
      flex: 1;
      height: 8px;
      background: #e9ecef;
      border-radius: 4px;
      
      .trainer-progress-bar {
        background: var(--trainer-primary);
        border-radius: 4px;
      }
    }
    
    .trainer-progress-text {
      font-size: 12px;
      font-weight: 600;
      color: var(--trainer-dark);
      min-width: 35px;
    }
  }
  
  .trainer-metric-change {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    
    i {
      margin-left: 5px;
      font-size: 12px;
    }
  }
  
  .trainer-actions {
    display: flex;
    gap: 5px;
    
    .btn {
      padding: 4px 8px;
      font-size: 12px;
    }
  }
}

.trainer-alerts {
  .trainer-alert-item {
    display: flex;
    align-items: center;
    padding: 15px;
    border-radius: 6px;
    margin-bottom: 15px;
    
    i {
      font-size: 20px;
      margin-right: 15px;
    }
    
    &.trainer-alert-warning {
      background: rgba(255, 193, 7, 0.1);
      border-left: 4px solid #ffc107;
      
      i {
        color: #ffc107;
      }
    }
    
    &.trainer-alert-success {
      background: rgba(40, 167, 69, 0.1);
      border-left: 4px solid #28a745;
      
      i {
        color: #28a745;
      }
    }
    
    &.trainer-alert-info {
      background: rgba(23, 162, 184, 0.1);
      border-left: 4px solid #17a2b8;
      
      i {
        color: #17a2b8;
      }
    }
  }
}

.trainer-upcoming-revals {
  .trainer-reval-item {
    display: flex;
    align-items: center;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 6px;
    margin-bottom: 15px;
    
    .trainer-reval-date {
      text-align: center;
      margin-right: 15px;
      min-width: 80px;
      
      strong {
        color: var(--trainer-primary);
        font-size: 16px;
      }
      
      small {
        color: #666;
      }
    }
    
    .trainer-reval-client {
      display: flex;
      align-items: center;
      flex: 1;
      
      .trainer-reval-avatar {
        width: 35px;
        height: 35px;
        border-radius: 50%;
        margin-right: 10px;
        object-fit: cover;
      }
    }
    
    .trainer-reval-actions {
      .btn {
        font-size: 12px;
        padding: 4px 12px;
      }
    }
  }
}

.form-control {
  border: 2px solid #e9ecef;
  border-radius: 6px;
  
  &:focus {
    border-color: var(--trainer-primary);
    box-shadow: 0 0 0 0.2rem rgba(154, 205, 50, 0.25);
  }
}
</style>